import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { notifyError, notifyTopRight } from "../Common/Toaster";
import { updateVipPremium } from "../../../services/UserServices/UserService";

const VipUser = ({ show, id, table, setLoader, onHide }) => {
  const [days, setDays] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (days === "" || Number(days) < 0) {
      notifyError("Please enter valid days");
      return;
    }

    setLoader(true);
    try {
      const payload = {
        userId: id,
        totalDays: +days,
      };
      await updateVipPremium(payload);
      notifyTopRight("Successfully");
      table();
      onHide();
      setDays("");
      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message || "An error occurred");
      console.error("Error:", error.response || error);
      setLoader(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={() => {
        setDays("");
        onHide();
      }}
      centered
    >
      <form onSubmit={handleSubmit}>
        <div className="modal-header">
          <h4 className="modal-title fs-20">VIP Member</h4>
        </div>
        <div className="modal-body">
          <div className="form-group mb-3">
            <label className="text-black font-w500">Days</label>
            <input
              type="number"
              className="form-control"
              value={days}
              min={0}
              required
              onChange={(e) => {
                setDays(e.target.value);
              }}
            />
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              setDays("");
              onHide();
            }}
            className="btn btn-danger"
          >
            <i className="flaticon-delete-1"></i> Cancel
          </button>
          <button type="submit" className="btn btn-primary">
            Submit
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default VipUser;
